var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.6914 2.6914 0 6 0C9.3086 0 12 2.6914 12 6C12 9.3086 9.3086 12 6 12C2.6914 12 0 9.3086 0 6ZM0.929508 6C0.929508 8.79551 3.20449 11.0705 6 11.0705C8.79551 11.0705 11.0705 8.79551 11.0705 6C11.0705 3.20449 8.79598 0.929508 6 0.929508C3.20449 0.929508 0.929508 3.20449 0.929508 6ZM6.46469 5.80484L8.13782 7.05969C8.34325 7.21353 8.38509 7.50493 8.23075 7.70991C8.13965 7.83261 8.00022 7.89629 7.85847 7.89629C7.76134 7.89629 7.66373 7.86608 7.58008 7.80333L5.72106 6.40906C5.60395 6.32169 5.53516 6.18364 5.53516 6.03725V3.2487C5.53516 2.99169 5.74291 2.78394 5.99992 2.78394C6.25694 2.78394 6.46469 2.99169 6.46469 3.2487V5.80484Z",
    fill: "#2B313C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.77f5b55a1248b64d4ddcc948f62d88c8.svg";
export { ForwardRef as ReactComponent };